import moment from 'moment';
import { ConfigConstants } from '../../config/config-constants';
import { ClientManagerInstanceToken } from '../../interfaces/client-manager.interface';
import { ConfigService } from '../../services/config/config.service';
import { CustomInjector } from '../../services/custom-injector/custom-injector';
import { TimesheetAndExpensesUtilities } from '../../utilities/timesheet-and-expenses-utilities';
import { TimesheetModel } from '../low-level/timesheet.model';
import { DateModelOptions } from '../options/date-model-options';
import { RadioModelOptions } from '../options/radio-model-options';
import { TimeModelOptions } from '../options/time-model-options';
import { DateModel } from '../primitive/date.model';
import { TextModel } from '../primitive/text.model';
import { TimeModel } from '../primitive/time.model';
import { CompositeModel } from './composite.model';
import { RadioModel } from './radio.model';
import { getNextTimesheetEntryCounter } from './timesheet-entry-counter';
import { TimesheetEntryInterface } from './timesheet-entry.interface';

export class TimesheetSowModel extends CompositeModel implements TimesheetEntryInterface {
    public startDate: DateModel;
    public startTime: TimeModel;
    public endDate: DateModel;
    public endTime: TimeModel;
    public startAddressOptions: RadioModel<TextModel>;

    public readonly index: number;
    public constructor(
        time: moment.Moment,
        isReadonly: boolean,
        currentTimesheet: TimesheetModel,
        submittedTimesheet?: TimesheetModel,
        startAddress?: string,
    ) {
        super('TimesheetSoWModel');

        const injector = CustomInjector.getInjector();
        const configService = injector.get(ConfigService);
        const timesheetAndExpensesUtilities = injector.get(TimesheetAndExpensesUtilities);
        const clientManager = injector.get(ClientManagerInstanceToken);
        this.index = getNextTimesheetEntryCounter();

        // work schedule service
        const entries = currentTimesheet.getTimesheetEntries();
        const firstStart = entries[0]
            ? entries[0].startDate.value
            : moment().add(ConfigConstants.maxAmountOfYears, 'years').startOf('minute');

        if (clientManager.isNgmAA()) {
            isReadonly = true;
        }
        // if its readonly then we cannot use the last EOW. In this case the current SOW would hurt the validation, as the previous EOW
        // would be the minimum value for SOW. But the already sent SOW is obviously before the sent EOW.
        const previousEow =
            !isReadonly && submittedTimesheet && submittedTimesheet.getEndOfWork().isValid()
                ? submittedTimesheet.getEndOfWork()
                : moment(0).startOf('minute');

        this.startDate = new DateModel(
            'StartDate',
            time,
            new DateModelOptions({ minValue: previousEow, maxValue: firstStart }),
        );
        this.startTime = new TimeModel(
            'StartTime',
            time,
            new TimeModelOptions({ minValue: previousEow, maxValue: firstStart }),
        );
        this.endDate = new DateModel(
            'EndDate',
            time,
            new DateModelOptions({ minValue: previousEow, maxValue: firstStart }),
        );
        this.endTime = new TimeModel(
            'EndTime',
            time,
            new TimeModelOptions({ minValue: previousEow, maxValue: firstStart }),
        );

        if (configService.getDisplayTimesheetAddressOptions()) {
            this.startAddressOptions = <RadioModel<TextModel>>this.set(
                new RadioModel<TextModel>(
                    'AddrNumber',
                    timesheetAndExpensesUtilities.getTimesheetAddressOptions(),
                    new RadioModelOptions({
                        initialSelection: 2,
                    }),
                ),
            );
            if (startAddress) {
                this.startAddressOptions.selectByPredicate((entry) => startAddress === entry.model.value);
            }
        }
    }
}
